export default {
  isOffline: false,
  hayDatos: false,
  idComparativa: 0,

  Presupuesto: {
    Tramos: [],
    DatosGenerales: {
      Nombre: '',
      ProvinciaId: 0,
      MunicipioId: 0,
      Tecnologia: '',
      ServicioId: 0,
      ActuacionId: 0,
      ProblemaId: 0,
      NivelFreatico: false,
      Trafico: false,
      MaterialId: 0,
      TerrenoId: 0,
      PavimentoId: 0,
      ProfundidadMedia: 0,
      Acometidas: 0,
      PozosRegistro: 0,
      Incidencias: 0,
      Id: 0,
      Email: '',
      Aplicacion: 0
      /*  Usuario:'' */
    }
  },

  DatosComparativa: {
    Beneficio: [],
    Costes: [],
    Tiempos: []
  },

  DatosListadoPresupuestos: {
    Id: 0,
    Fecha: '',
    Nombre: '',
    Provincia: '',
    Municipio: '',
    Estado: '',
    Servicio: '',
    Tecnologia: '',
    CosteTcz: 0,
    CosteTsz: 0,
    BeneficioCoste: 0,
    BeneficioTiempo: 0,
    BeneficioRuido: 0,
    BeneficioCo2: 0
  },

  Usuario: {
    user: {
      mail: '',
      isExternal: '',
      appName: '',
      password: '',
      id: 0
    },
    profile: {
      nombre: '',
      apellidos: '',
      empresa: '',
      telefono: '',
      id: 0
    },
    id: 0
  },

  UsuarioRegistro: {
    mail: '',
    token: ''
  },

  user: {
    userName: '',
    password: '',
    mail: '',
    ldap: false,
    salt: '',
    admin: false,
    enabled: false,
    id: 0,
    apps: {
      tsz: {
        showTree: true,
        portfolio: [],
        rolAplicacion: -1
      }
    }
  }
};
